import React from "react";
import { HashLink } from "./HashLink";
import { useLang } from "./LangContext";
import { useTenant } from "./TenantContext";
import { HERO_IMAGE } from "./data";
import { ChevronDown } from "lucide-react";

export default function Hero() {
    const { t } = useLang();
    const { tenant } = useTenant();
    const hero = tenant?.hero || {};
    return (
        <section
            id="hero"
            data-testid="hero-section"
            className="relative min-h-screen w-full overflow-hidden"
        >
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${hero.image_url || HERO_IMAGE})` }}
            />
            <div className="absolute inset-0 hero-overlay" />

            <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 pt-20">
                <div className="text-center max-w-4xl fade-up">
                    <span className="inline-block text-white/80 text-xs font-semibold tracking-[0.3em] uppercase mb-6 border border-white/30 px-4 py-1.5 rounded-full backdrop-blur-sm bg-white/5">
                        {hero.badge || "Sardegna · Barigadu"}
                    </span>
                    <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-semibold text-white leading-[1.05] drop-shadow-2xl">
                        {hero.title || t.hero_title}
                    </h1>
                    <p className="mt-6 text-lg md:text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
                        {hero.subtitle || t.hero_sub}
                    </p>
                    <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                        <HashLink
                            to="/"
                            hash="#il-borgo"
                            className="btn-primary px-8 py-4 rounded-full font-semibold shadow-lg"
                            data-testid="hero-cta-scopri"
                        >
                            {hero.cta_primary_label || t.cta_scopri}
                        </HashLink>
                        <HashLink
                            to="/gemello-digitale"
                            className="btn-outline-white px-8 py-4 rounded-full font-semibold"
                            data-testid="hero-cta-gemello"
                        >
                            {hero.cta_secondary_label || t.cta_gemello}
                        </HashLink>
                    </div>
                </div>

                <div className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/80 bounce-down">
                    <ChevronDown size={30} />
                </div>
            </div>
        </section>
    );
}
